module.exports = __webpack_public_path__ + "static/fonts/Roboto300.c6cdfded.ttf";